import { createSlice } from "@reduxjs/toolkit";
import { users } from "../fake-db/users";
import { UserType } from "../types/userType";

interface stateType {
  users: UserType[];
  searchQuery: string;
}

const initialState: stateType = {
  users: users,
  searchQuery: "",
};

export const searchSlice = createSlice({
  name: "searchSlice",
  initialState,
  reducers: {
    searchUser: (state, action) => {
      const filterData = () => {
        const data = users.filter((item) => {
          return item.name.toLowerCase().includes(action.payload.toLowerCase());
        });
        if (data.length === 0) {
          return users;
        } else {
          return data;
        }
      };
      state.users = filterData();
      state.searchQuery = action.payload;
    },
  },
});

export const { searchUser } = searchSlice.actions;

export default searchSlice.reducer;
